import { render, staticRenderFns } from "./job-offers.vue?vue&type=template&id=467caa1b"
import script from "./job-offers.vue?vue&type=script&lang=js"
export * from "./job-offers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports